import { toast } from 'sonner'

/**
 * Shows a confirmation dialog using Sonner toast with action buttons
 * @param {string|Object} messageOrOptions - The confirmation message or options object
 * @param {Object} options - Optional configuration (if first param is string)
 * @param {string} options.title - Title for the dialog
 * @param {string} options.message - The confirmation message to display
 * @param {string} options.confirmText - Text for confirm button (default: "Continue")
 * @param {string} options.cancelText - Text for cancel button (default: "Cancel")
 * @param {string} options.description - Additional description text
 * @returns {Promise<boolean>} - Resolves to true if confirmed, false if cancelled
 */
export function confirmDialog(messageOrOptions, options = {}) {
  // Handle both API styles:
  // confirmDialog('message', { confirmText, cancelText })
  // confirmDialog({ title, message, confirmText, cancelText })
  let title, message, confirmText, cancelText, description
  
  if (typeof messageOrOptions === 'string') {
    // Old API: confirmDialog(message, options)
    message = messageOrOptions
    confirmText = options.confirmText || 'Continue'
    cancelText = options.cancelText || 'Cancel'
    description = options.description || null
    title = options.title || null
  } else {
    // New API: confirmDialog({ title, message, confirmText, cancelText })
    title = messageOrOptions.title || null
    message = messageOrOptions.message
    confirmText = messageOrOptions.confirmText || 'Continue'
    cancelText = messageOrOptions.cancelText || 'Cancel'
    description = messageOrOptions.description || null
  }

  return new Promise((resolve) => {
    toast(title || message, {
      description: title ? message : description,
      duration: Infinity, // Don't auto-dismiss
      action: {
        label: confirmText,
        onClick: () => resolve(true)
      },
      cancel: {
        label: cancelText,
        onClick: () => resolve(false)
      },
      onDismiss: () => resolve(false), // Treat dismissal as cancel
      onAutoClose: () => resolve(false)
    })
  })
}

